import React, {PureComponent} from 'react'
import StripeCCForm from '../CreateSubscription/Billing/StripeCCForm'
import AcceptedPayments from '../CreateSubscription/AcceptedPayments'
import popup from '../../popup'
import { updateStripePayment, updateUserCard } from '~/redux/user/helpers'
import './style.css'

class UpdateStripePayment extends PureComponent {
  render() {
    return (
      <div className="update-stripe-payment centered opaque padded">
        <h2>Update Billing Information</h2>
        <AcceptedPayments />
        <StripeCCForm
          submitCaption="UPDATE"
          apiKey={ ((window.settings.paymentProviders || {}).stripe || {}).apiKey }
          onToken={ this.handleToken } />
      </div>
    )
  }
  handleToken = (o) => {
    let userObj = this.props.user
    userObj.billingInfo = { stripeToken: o }
    updateUserCard(userObj)
    return updateStripePayment(o).then(popup.hide)
  }
}

export default UpdateStripePayment;
